import {
    STORE_EMPLOYEES, STORE_ONLINE_EMPLOYEES,
    STORE_TOKEN, STORE_USERS, UPDATE_SELECTED_COMPANY, UPDATE_USER_ID, UPDATE_USER_INFO,
} from '../../constants/auth';
import storage from 'redux-persist/lib/storage';
import {persistReducer} from "redux-persist";

import {AUTH_KEY} from "../../constants/keys";
import {STORE_RFID} from "../../constants/userManagement";
import { HIDE_LICENSE_DIALOG, SHOW_LICENSE_DIALOG } from '../../constants/global';

const initialState = {
    token: null,
    userInfo: {},
    users: [],
    rfid: null,
    isAuthenticated: false,
    employees: [],
    showLicenseDialog: false,
    onlineEmployees: [],
}

const auth = (state = initialState, action) => {
    switch (action.type) {
        case STORE_TOKEN:
            return {
                ...state,
                token: action.token,
                userInfo: action.userInfo,
                isAuthenticated: action.isAuthenticated
            }

        case SHOW_LICENSE_DIALOG:
            return { ...state, showLicenseDialog: true }
        case HIDE_LICENSE_DIALOG:

            return { ...state, showLicenseDialog: false }
        case STORE_USERS:
            return {
                ...state,
                users: action.users
            }
        case STORE_EMPLOYEES:
            return {
                ...state,
                employees: action.employees
            }
        case STORE_ONLINE_EMPLOYEES:
            return {
                ...state,
                onlineEmployees: action.employees
            }
        case UPDATE_USER_INFO:
            return {
                ...state,
                userInfo: action.userInfo
            }
        case UPDATE_SELECTED_COMPANY:
            return {
                ...state,
                userInfo: { ...state.userInfo, selectedLocationId: action.selectedCompany,selectedLocationName: action.selectedLocationName },
            }
        case UPDATE_USER_ID:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    ...action.user,
                }
            }
        case STORE_RFID:
            return {
                ...state,
                rfid: action.user.rfid,
            }
        default:
            return state
    }
}

const config = {
    key: AUTH_KEY,
    storage: storage,
    whitelist: ['isAuthenticated', 'userInfo', 'users'],
};

export default persistReducer(config, auth)